import { displayToastError, http } from 'app';

export const createNewChat = async (
  businessArea: string,
  service: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/new-chat'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Create New Chat');
    throw error;
  }
};

export const getChatMessages = async (
  businessArea: string,
  service: string,
  chatId: string
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/get-messages'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      { chatId }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Get Chat Messages');
    throw error;
  }
};

export const renameChat = async (
  businessArea: string,
  service: string,
  chatId: string,
  newChatName: string
): Promise<any> => {
  try {
    const response = await http.patch(
      '/:businessArea/:service/rename-chat'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        chatId,
        newChatName
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Rename Chat');
    throw error;
  }
};

export const deleteChat = async (
  businessArea: string,
  service: string,
  chatId: string
): Promise<any> => {
  try {
    const response = await http.delete(
      '/:businessArea/:service/delete-chat'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        data: { chatId }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Delete Chat');
    throw error;
  }
};

export const deleteChatMessages = async (
  businessArea: string,
  service: string,
  chatId: string,
  timestamp: any
): Promise<any> => {
  try {
    const response = await http.delete(
      '/:businessArea/:service/delete-messages'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        data: {
          chatId,
          timestamp
        }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Delete Chat Messages');
    throw error;
  }
};

export const ask = async (
  businessArea: string,
  service: string,
  payload: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/ask'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      payload
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Ask');
    throw error;
  }
};

export const uploadDocuments = async (
  businessArea: string,
  service: string,
  payload: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/upload-documents'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Upload Documents');
    throw error;
  }
};

export const downloadDocument = async (
  businessArea: string,
  service: string,
  documentPath: string,
  searchable: boolean
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/download-document'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        documentPath,
        searchable
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Download Document');
    throw error;
  }
};

export const deleteDocument = async (
  businessArea: string,
  service: string,
  documentPath: string
): Promise<any> => {
  try {
    const response = await http.delete(
      '/:businessArea/:service/delete-document'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        data: { documentPath }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Delete Document');
    throw error;
  }
};

export const renameDocument = async (
  businessArea: string,
  service: string,
  payload: any
): Promise<any> => {
  try {
    const response = await http.patch(
      '/:businessArea/:service/rename-document'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      payload
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Rename Document');
    throw error;
  }
};

export const moveOrCopyDocument = async (
  businessArea: string,
  service: string,
  payload: any
): Promise<any> => {
  try {
    const response = await http.patch(
      '/:businessArea/:service/move-document'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      payload
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Move or Copy Document');
    throw error;
  }
};

export const translateDocument = async (
  businessArea: string,
  service: string,
  payload: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/translate-document'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      payload
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Translate Document');
    throw error;
  }
};

export const createDocumentFolder = async (
  businessArea: string,
  service: string,
  folderName: string
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/create-folder'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      { folderName }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Create Document Folder');
    throw error;
  }
};

export const renameDocumentFolder = async (
  businessArea: string,
  service: string,
  folderName: string,
  newFolderName: string
): Promise<any> => {
  try {
    const response = await http.patch(
      '/:businessArea/:service/rename-folder'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        folderName,
        newFolderName
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Rename Document Folder');
    throw error;
  }
};

export const deleteDocumentFolder = async (
  businessArea: string,
  service: string,
  folderName: string
): Promise<any> => {
  try {
    const response = await http.delete(
      '/:businessArea/:service/delete-folder'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      {
        data: { folderName }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Delete Document Folder');
    throw error;
  }
};

export const getHistory = async (
  businessArea: string,
  service: string,
  filter?: string
): Promise<any> => {
  try {
    const queryParams = filter ? `?filter=${encodeURIComponent(filter)}` : '';
    const response = await http.get(
      '/:businessArea/:service/history'
        .replace(':businessArea', businessArea)
        .replace(':service', service) + queryParams
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Get History');
    throw error;
  }
};
